var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartWrapper",staticClass:"widget-wrapper pad0"},[_c('data-table',{ref:"widgetDataTable",staticClass:"bs bs-data-table bs-data-table-slim",attrs:{"fields":_vm.widgetFields,"complexHeader":_vm.widgetComplexHeader,"data":_vm.widgetData,"virtualScrolling":false,"fieldSortable":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }